import { em, math } from 'polished'
import styled from 'styled-components'

import SectionWrapper from 'components/SectionWrapper'
import SliderMobile from 'components/SliderMobile'
import { setBackground } from 'utils/styled/setBackground'

export const SectionWrapperStyled = styled(SectionWrapper)`
  padding-top: ${em(40)};
  padding-bottom: ${em(10)};
  text-align: center;
  color: ${p => p.theme.colors.white};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(60)};
    padding-bottom: ${em(60)};
    min-height: ${em(532)};
  }
`

export const SectionCover = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background: 50% 0 / cover no-repeat;
  ${({ coverUrl }) => setBackground('jpg', coverUrl, { xs: 320, md: 1280 })};
  z-index: -2;
`

export const SliderWrapper = styled.div`
  margin-left: -${p => p.theme.indents.baseIndentXs};
  margin-right: -${p => p.theme.indents.baseIndentXs};
`

export const SliderMobileStyled = styled(SliderMobile)`
  // calculate indent for inject there button + padding around it
  padding-bottom: ${p => math(`${p.theme.buttons.hActionBtn} + ${em(20)} * 2`)};
`

export const ButtonBlock = styled.div`
  position: absolute;
  left: 0;
  bottom: ${p => math(`${p.theme.buttons.hActionBtn} + ${em(40)}`)};
  width: 100%;

  ${p => p.theme.mq.upMd} {
    position: static;
  }
`
